import React from 'react'
import { Outlet } from 'react-router-dom'

import { AssessmentProcessHeader } from '../components/layout/AssessmentProcessHeader'
import { AssessmentProcessNavigation } from '../components/layout/AssessmentProcessNavigation'
import { useAssessmentProcess } from '../contexts/AssessmentProcessContext'

export const AssessmentProcessLayout: React.FC = () => {
  const { loading, error, assessment } = useAssessmentProcess()

  // Loading and error states are now handled by React Query in the provider

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Cargando assessment...</p>
        </div>
      </div>
    )
  }

  // Only show full error page for critical loading errors (when no assessment data is available)
  // Mutation errors (like evaluation update failures) should NOT trigger this error page
  if (error && !assessment) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Error al cargar assessment</h2>
          <p className="text-gray-600">{error}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <AssessmentProcessHeader />

      {/* Navigation */}
      <AssessmentProcessNavigation />

      {/* Main Content */}
      <main className="flex-1 min-h-0">
        <Outlet />
      </main>
    </div>
  )
}
